import React from "react";
import type { PropsWithChildren } from "react";

import { horizontalProductCardHeader } from "./HorizontalProductCard.css";

export const HorizontalProductCardHeader: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={horizontalProductCardHeader}>{children}</div>;
};
